// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Start_wrapper__n-lKy","logo":"Start_logo__GHE3A","platform":"Start_platform__1wLnh"};